import { Injectable } from '@angular/core';

import { TranslateParser } from '@ngx-translate/core';

import ReleaseNoteTemplate from '../../assets/template/releasenote.template.json';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkReleaseNoteService {
  public keyUpEvent = new Subject<KeyboardEvent>();
  constructor(private readonly translate: TranslateParser) {}

  /**
   * Returns rdfa markup for release-notes
   * @public
   * @param {string} threadId
   * @param {string} content
   * @returns {string}
   */
  public getReleaseNoteTemplate(threadId: string, content: string): string {
    return this.translate.interpolate(
      ReleaseNoteTemplate.RELEASE_NOTE_CREATE_TEMPLATE,
      {
        threadId,
        content,
      }
    );
  }
}
